/* eslint-disable react-hooks/exhaustive-deps */
import "../App.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import "../css/Visualisasi.css";
import { useState } from "react";
import { requestWithHeaders } from "../api/requestMethods";
import DatePicker from "react-date-picker";
import { endOfToday, format } from "date-fns";
import { BeatLoader } from "react-spinners";
import PieChartComponent from "../components/PieChartComponent";
import BarChartComponent from "../components/BarChartComponent";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

function Visualisasi() {
  const [rekap, setRekap] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startPeriod, setStartPeriod] = useState(null);
  const [endPeriod, setEndPeriod] = useState(null);

  const service_types = [
    { service_type: 1, name: "Mahasiswa" },
    { service_type: 2, name: "Calon Mahasiswa" },
    { service_type: 3, name: "Dosen" },
    { service_type: 4, name: "Tenaga Pendidik" },
    { service_type: 5, name: "Masyarakat" },
    { service_type: 6, name: "Alumni" },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await requestWithHeaders.get(
        `/api/admin/locket-recap?startPeriod=${format(
          startPeriod,
          "yyyy-MM-dd"
        )}&endPeriod=${format(endPeriod, "yyyy-MM-dd")}`
      );
      const jsonData = res?.data?.data;
      const convertedRekap = [];
      jsonData.map((data, i) => {
        let convObj = { ...data };
        delete convObj.user;
        delete convObj.user_id;
        convObj.service_type = service_types[data.service_type - 1]?.name;
        const combined = { ...convObj, ...data?.user };
        return convertedRekap.push(combined);
      });
      setRekap(convertedRekap);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
    setLoading(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const submitPeriod = () => {
    fetchData();
  };

  return (
    <div>
      <Topbar />
      <div className="row">
        <div className="col-md-2">
          <Sidebar />
        </div>
        <div
          className="col-md-10"
          style={{ marginLeft: "250px", paddingTop: "56px" }}
        >
          <div className="row px-5 mt-5">
            <div className="card shadow h-100 py-2 pl-3 w-100">
              <div className="card-body pt-2 pr-3">
                <div
                  className=" mx-3 mt-3 mb-3 row"
                  style={{ fontSize: 24, fontWeight: 700 }}
                >
                  Visualisasi Data Antrian Layanan
                </div>
                <hr />
                <div className="row ml-2 d-flex align-items-center">
                  <span className="col-md-2">Periode Antrian</span>
                  <span className="col-md-2 Sample__container">
                    <main className="Sample__container__content">
                      <DatePicker
                        disabled={loading}
                        value={startPeriod}
                        className="datepicker"
                        locale="id"
                        onChange={setStartPeriod}
                        format="dd/MM/yyyy"
                        maxDate={endOfToday()}
                      />
                    </main>
                  </span>
                  -
                  <span className="col-md-2 Sample__container">
                    <main className="Sample__container__content">
                      <DatePicker
                        disabled={loading}
                        value={endPeriod}
                        locale="id"
                        className="datepicker"
                        onChange={setEndPeriod}
                        format="dd/MM/yyyy"
                        maxDate={endOfToday()}
                      />
                    </main>
                  </span>
                </div>
                <div className="row my-3 mx-3 d-flex justify-content-between">
                  <button
                    className="btn btn-rekap"
                    onClick={() => submitPeriod()}
                    disabled={loading || !startPeriod || !endPeriod}
                  >
                    {!loading ? (
                      "Submit"
                    ) : (
                      <BeatLoader size={8} color="#fff" margin={2} />
                    )}
                  </button>
                </div>
                <hr className="mt-3" />
                <div className="row mx-3 mt-3"></div>
              </div>
              <div className="card-body pt-2 pr-3">
                <div className="">
                  {rekap?.length === 0 ? (
                    <>
                      <tr className=" w-100 d-flex align-items-center justify-content-center">
                        <td colSpan={7}>
                          <div className="img-bg w-100 d-flex align-items-center justify-content-center">
                            <div>
                              <img
                                className="row ml-5"
                                src="images/not-found.png"
                                alt="Not Found"
                              />
                              <p className="mt-1 nf-text">
                                Anda belum memasukkan periode antrian
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      <div
                        className=" mx-3 mt-3 mb-3 row"
                        style={{ fontSize: 20, fontWeight: 600 }}
                      >
                        visualisasi data berdasarkan jenis layanan
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <BarChartComponent
                          data={rekap}
                          groupByKey="service_name"
                          width={1000}
                          height={500}
                          showTooltip={true}
                        />
                      </div>

                      <hr className="mt-3" />
                      <div className="row mx-3 mt-3"></div>

                      <div
                        className=" mx-3 mt-3 mb-3 row"
                        style={{ fontSize: 20, fontWeight: 600 }}
                      >
                        visualisasi data berdasarkan status pengunjung
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <PieChartComponent
                          data={rekap}
                          groupByKey="user_status"
                          colors={["#4e73df", "#1cc88a", "#36b9cc", "#f6c23e"]}
                          width={1000}
                          height={500}
                          outerRadius={180}
                          innerRadius={0}
                          showTooltip={true}
                          showLabel={true}
                        />
                      </div>

                      <hr className="mt-3" />
                      <div className="row mx-3 mt-3"></div>

                      <div
                        className=" mx-3 mt-3 mb-3 row"
                        style={{ fontSize: 20, fontWeight: 600 }}
                      >
                        visualisasi data berdasarkan jumlah antrian yang
                        dilayani petugas tiap loket
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <PieChartComponent
                          data={rekap}
                          groupByKey="locket_number"
                          colors={["#4e73df", "#1cc88a", "#36b9cc", "#f6c23e"]}
                          width={1000}
                          height={500}
                          outerRadius={180}
                          innerRadius={0}
                          showTooltip={true}
                          showLabel={true}
                        />
                      </div>

                      <hr className="mt-3" />
                      <div className="row mx-3 mt-3"></div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Visualisasi;
